import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ArrowRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { COMPANY } from "@/data/content";
import { useT, useRoute } from "@/i18n";

export default function ContactStrip() {
  const t = useT();
  const route = useRoute();
  return (
    <section className="bg-white py-24 md:py-32 border-t border-black/5" data-testid="contact-strip">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal>
          <p className="eyebrow">{t.contactStrip.eyebrow}</p>
          <h2 className="heading-display mt-3 text-5xl sm:text-6xl uppercase">
            <span className="text-[#C20E1A]">{t.contactStrip.title}</span>
          </h2>
          <p className="mt-6 text-lg text-black/75 leading-relaxed max-w-lg">{t.contactStrip.body}</p>
          <Link
            to={route("contact")}
            data-testid="contact-now-btn"
            className="mt-8 inline-flex items-center gap-3 bg-[#C20E1A] text-white px-9 py-4 text-[11px] uppercase tracking-[0.25em] font-bold hover:bg-black transition-colors duration-500"
          >
            {t.contactStrip.cta} <ArrowRight size={14} />
          </Link>
        </Reveal>

        <Reveal delay={120} className="space-y-6">
          <div className="flex items-start gap-4 border-l-2 border-[#C20E1A] pl-5">
            <MapPin className="text-[#C20E1A] mt-1" size={20} />
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] font-bold text-black/60">
                {t.contactStrip.address}
              </p>
              <p className="mt-1 text-base text-black">{COMPANY.address}</p>
            </div>
          </div>
          <div className="flex items-start gap-4 border-l-2 border-[#C20E1A] pl-5">
            <Phone className="text-[#C20E1A] mt-1" size={20} />
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] font-bold text-black/60">
                {t.contactStrip.phone}
              </p>
              <p className="mt-1 text-base text-black">{COMPANY.phone}</p>
            </div>
          </div>
          <div className="flex items-start gap-4 border-l-2 border-[#C20E1A] pl-5">
            <Mail className="text-[#C20E1A] mt-1" size={20} />
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] font-bold text-black/60">
                {t.contactStrip.email}
              </p>
              <a
                href={`mailto:${COMPANY.email}`}
                className="mt-1 inline-block text-base text-black hover:text-[#C20E1A]"
              >
                {COMPANY.email}
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
